import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import getUrl from './getUrl';
const TOTAL_SIZES = 2;
function createSrcSet(cdnSrc) {
  const srcSet = [];
  for (let i = 0; i < TOTAL_SIZES; i += 1) {
    const size = i + 1;
    srcSet.push(`${cdnSrc}&dpr=${size} ${size}x`);
  }
  return srcSet.join(',');
}
const ImageCdn = t0 => {
  const $ = _c(19);
  let otherProps;
  let src;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      src,
      alt: t1,
      height: t2,
      width: t3,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = src;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    otherProps = $[1];
    src = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const alt = t1 === undefined ? "" : t1;
  const height = t2 === undefined ? null : t2;
  const width = t3 === undefined ? null : t3;
  const [hasLoadingError, setLoadingError] = useState(false);
  const t4 = width || null;
  const t5 = height || null;
  let t6;
  if ($[6] !== alt || $[7] !== otherProps || $[8] !== t4 || $[9] !== t5) {
    t6 = {
      alt,
      width: t4,
      height: t5,
      ...otherProps
    };
    $[6] = alt;
    $[7] = otherProps;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const commonImageProps = t6;
  let t7;
  if ($[11] !== hasLoadingError || $[12] !== height || $[13] !== src || $[14] !== width) {
    const proxifiedUrl = getUrl(src, width, height);
    const isNonProxifiableUrl = proxifiedUrl === src;
    t7 = hasLoadingError || isNonProxifiableUrl ? {
      src
    } : {
      src: proxifiedUrl,
      srcSet: createSrcSet(proxifiedUrl),
      onError: () => {
        setLoadingError(true);
      }
    };
    $[11] = hasLoadingError;
    $[12] = height;
    $[13] = src;
    $[14] = width;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const imageProps = t7;
  let t8;
  if ($[16] !== commonImageProps || $[17] !== imageProps) {
    t8 = <img {...commonImageProps} {...imageProps} />;
    $[16] = commonImageProps;
    $[17] = imageProps;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
export default ImageCdn;